import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

export const agreementSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add your agreements.',
        description:
            '<p>Title your agreement with a descriptive name so you can easily identify it. </p> <p>Title your agreement with a descriptive name so you can easily identify it. Next, type your policy or copy and paste text from an existing document. Any formatting you have (headings, bullet points, etc.) will be preserved when you paste.</p>',
        image: 'images/sliders/agreement/slider-agreement-1.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an agreement?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Choose when the agreement is sent.',
        description:
            '<p><strong>First Booking:</strong>The agreement is sent only on a client’s first visit.</p> <p><strong>Every Booking:</strong> The agreement is sent every time a client makes a booking.</p><p><strong>Manually:</strong> You can send the agreement to the client whenever needed.</p>',
        image: 'images/sliders/agreement/slider-agreement-2.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an agreement?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446'
    },
    {
        id: 3,
        stepNumber: 3,
        title: 'Manage your Agreements.',
        description:
            '<p>View and manage all your signed and unsigned agreements in one place.</p> <p>You can view when each agreement was sent, when it was signed, and you can also preview or send copies any time you need.</p>',
        image: 'images/sliders/agreement/slider-agreement-3.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an agreement?',
        videoDuration: '0:28',
        videoUrl: 'https://www.loom.com/share/f70498401c0944d782e186126fe8d446'
        /*primaryButton: {
            text: 'View Agreement Templates',
            href: 'mailto:help@cuddlesapp.com',
            target: '_blank',
            rel: 'noreferrer',
            color: '#92B4A7',
            hoverColor: '#92B4A7'
        }*/
    }
];
